import type { ToastMessageOptions } from 'primevue/toast';

export const prepareToast = (
  severity: 'success' | 'info' | 'warn' | 'error' | 'secondary' | 'contrast' | undefined,
  summary: string,
  message: string,
  timout: number = 3000
) : ToastMessageOptions => {
  return {
    severity,
    summary,
    detail: message,
    life: timout
  };
};
